export default __webpack_public_path__ + "static/media/mobile_deck.ba4463fc.webp";